
import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Feedback } from './useFeedbackData';

type FeedbackHeaderProps = {
  feedback: Feedback;
  formatDate: (date: string) => string;
  onBack: () => void;
};

export const FeedbackHeader = ({ feedback, formatDate, onBack }: FeedbackHeaderProps) => {
  // Déterminer si c'est un feedback de candidat vers recruteur
  const isCandidateFeedback = feedback.feedback_type === 'candidat';

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <Button variant="outline" onClick={onBack}>
          Retour
        </Button>
        {feedback.certified && (
          <Badge className="ml-2 py-1 px-3">
            Feedback certifié
          </Badge>
        )}
      </div>

      <CardHeader>
        <div className="flex justify-between items-start">
          <div>
            {isCandidateFeedback ? (
              // Pour un feedback de candidat vers recruteur
              <>
                <CardTitle className="text-2xl">
                  {feedback.recruiter_name || 'Recruteur'}
                </CardTitle>
                <CardDescription className="text-lg">
                  {feedback.job_title} - Feedback candidat
                </CardDescription>
              </>
            ) : (
              // Pour un feedback de recruteur vers candidat
              <>
                <CardTitle className="text-2xl">
                  {feedback.candidate_name}
                </CardTitle>
                <CardDescription className="text-lg">
                  {feedback.job_title}
                </CardDescription>
              </>
            )}
          </div>
          <div className="text-right text-sm text-gray-500">
            <div>Créé le {formatDate(feedback.created_at)}</div>
            <div className="mt-1">
              {isCandidateFeedback ? (
                // Pour un feedback de candidat vers recruteur
                <>Par {feedback.candidate_name || 'Candidat'}</>
              ) : (
                // Pour un feedback de recruteur vers candidat
                <>Par {feedback.recruiter_name || 'Recruteur'}</>
              )}
            </div>
          </div>
        </div>
      </CardHeader>
    </>
  );
};
